module.exports = __webpack_public_path__ + "img/20190611_113036_014.a42f804e.jpg";